import { useState } from 'react'
import { LoginImport } from './Import'
const { login_banner, Leaf, BarChart3, ShieldCheck, UserLoginForm, UserSignupForm, Aos, } = LoginImport

export default function UserLogin() {

    Aos.init();
    const [toggle, setTogggle] = useState(false)

    return (
        <>
            <div className='row side_bg g-0'>
                <div className="col-lg-7 p-0 d-none d-lg-block">
                    <div className='login_hero_panel'>
                        <img src={login_banner} alt="" className='login_hero_bg' />
                        <div className='login_hero_overlay'></div>
                        <div className='login_hero_overlay_bottom' aria-hidden="true"></div>
                        <Leaf className='login_hero_leaf' />
                        <div className='login_hero_content'>
                            <div className='login_logo'>
                                <span className='login_logo_af'><span className='af_a me-2'>alexa</span><span className='af_f'>farms</span></span>
                                {/* <span className='login_logo_text'>ALEXA FARMS</span> */}
                            </div>

                            <div>
                                <h1 className='login_hero_title mt-5'>
                                    Smart Farming.<br />
                                    <span style={{ color: '#7ed957' }}>Better Growth.</span><br />
                                    Sustainable Future.
                                </h1>
                                <div className='login_hero_divider'></div>
                                <p className='login_hero_sub'>Empowering farmers with technology, insights and innovation to build a better tomorrow.</p>
                            </div>

                            <div className='login_hero_bottom'>
                                <div className='login_features'>
                                    <div className='login_feature'>
                                        <div className='login_feature_icon'><Leaf size={18} /></div>
                                        <div>
                                            <h6>Boost Productivity</h6>
                                            <small>Optimize yield and resource use</small>
                                        </div>
                                    </div>
                                    <div className='login_feature'>
                                        <div className='login_feature_icon'><BarChart3 size={18} /></div>
                                        <div>
                                            <h6>Data Driven</h6>
                                            <small>Make smarter decisions with real-time insights</small>
                                        </div>
                                    </div>
                                    <div className='login_feature'>
                                        <div className='login_feature_icon'><ShieldCheck size={18} /></div>
                                        <div>
                                            <h6>Sustainable</h6>
                                            <small>Build a greener and sustainable future</small>
                                        </div>
                                    </div>
                                </div>

                                <div className='login_hero_footer'>
                                    <span>© 2025 Alexa Farms. All Rights Reserved.</span>
                                    <span>Developed by <u style={{ cursor: 'pointer' }} onClick={() => window.open('https://www.techlene.com/', '_blank')}>Techlene Software Solutions Pvt. Ltd.</u></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {!toggle ?
                    <div className="col-sm-12 col-lg-5 position-relative" data-aos="fade-left" data-aos-duration="1000">
                        <UserLoginForm setTogggle={setTogggle} />
                    </div>
                    : ''
                }

                {toggle ?
                    <div className="col-sm-12 col-lg-5 position-relative" data-aos="fade-left" data-aos-duration="1000">
                        <UserSignupForm setTogggle={setTogggle} />
                    </div>
                    : ''
                }
            </div>
        </>
    )
}
